import LocationTool from "./NewLocationWidget";
export default LocationTool;